import { AppState } from '../index';
import * as fromConfig from './config.reducer';
import { createSelector } from '@ngrx/store';
import { ProcessType } from '../../model/process-type.model';
import { ApiState } from '../../model/api-state.model';
import { selectProcessKind } from '../process/process.reducer';

export const selectConfigState = createSelector(
  (state: AppState) => state.config,
  ({ state }: fromConfig.State) => state,
);

export const selectConfigIsLoading = createSelector(
  (state: AppState) => state.config,
  ({ state }: fromConfig.State) => state === ApiState.idle || state === ApiState.pending,
);

export const selectConfigData = createSelector(
  (state: AppState) => state.config,
  ({ data }: fromConfig.State) => data,
);

export const selectConfigError = createSelector(
  (state: AppState) => state.config,
  ({ error }: fromConfig.State) => error,
);

export const selectConfigTripAbroad = createSelector(
  (state: AppState) => state.config,
  ({ data }: fromConfig.State) => data?.paths.find((path) => path.codeName === ProcessType.TRIPABROAD),
);

export const selectConfigResignation = createSelector(
  (state: AppState) => state.config,
  ({ data }: fromConfig.State) => data?.paths.find((path) => path.codeName === ProcessType.RESIGNATION),
);

export const selectConfigTravelInPl = createSelector(
  (state: AppState) => state.config,
  ({ data }: fromConfig.State) => data?.paths.find((path) => path.codeName === ProcessType.TRAVELINPL),
);

export const selectConfigTripAbroadCountries = createSelector(selectConfigTripAbroad, (data) => data?.destination?.countries);

export const selectConfigResignationLimitPerInsuredPerson = createSelector(
  selectConfigResignation,
  (data) => data?.resignationLimitPerInsuredPerson,
);

export const selectConfigAgentValidation = createSelector(
  selectProcessKind,
  selectConfigTravelInPl,
  selectConfigTripAbroad,
  selectConfigResignation,
  (kind, travelInPl, tripAbroad, resignation) => {
    switch (kind) {
      case ProcessType.RESIGNATION:
        return {
          agentMaxPriceDiscountPercent: resignation?.agentMaxPriceDiscountPercent,
          agentMaxPriceIncreasePercent: resignation?.agentMaxPriceIncreasePercent,
          agentMinPriceDiscountPercent: resignation?.agentMinPriceDiscountPercent,
          agentMinPriceIncreasePercent: resignation?.agentMinPriceIncreasePercent,
        };
      case ProcessType.TRAVELINPL:
        return {
          agentMaxPriceDiscountPercent: travelInPl?.agentMaxPriceDiscountPercent,
          agentMaxPriceIncreasePercent: travelInPl?.agentMaxPriceIncreasePercent,
          agentMinPriceDiscountPercent: travelInPl?.agentMinPriceDiscountPercent,
          agentMinPriceIncreasePercent: travelInPl?.agentMinPriceDiscountPercent,
        };
      case ProcessType.TRIPABROAD:
        return {
          agentMaxPriceDiscountPercent: tripAbroad?.agentMaxPriceDiscountPercent,
          agentMaxPriceIncreasePercent: tripAbroad?.agentMaxPriceIncreasePercent,
          agentMinPriceDiscountPercent: tripAbroad?.agentMinPriceDiscountPercent,
          agentMinPriceIncreasePercent: tripAbroad?.agentMinPriceDiscountPercent,
        };
      default:
        throw new Error('Unknown process kind');
    }
  },
);

export const selectGlobtroterMenuConfig = createSelector(
  (state: AppState) => state.config,
  (data) => data?.menuConfigData?.result,
);

export const selectGlobtroterUserName = createSelector(
  (state: AppState) => state.config,
  (data) => `${data?.globtroterUserData?.user.firstName ?? ''} ${data.globtroterUserData?.user.lastName ?? ''}`,
);

export const selectGlobtroterTheme = createSelector(
  (state: AppState) => state.config,
  (data) => data.globtroterConfigData?.theme,
);
